<script setup lang="ts">
import type { InteractionType } from '@azure/msal-browser';
import Button from 'primevue/button';
import { useLogin } from '@precon-tools-suite-by-shared/vue-msal';

const props = withDefaults(
    defineProps<{
        label?: string | null;
        icon?: string | null;
        loading?: boolean;
        disabled?: boolean;
        interactionType?:
            | InteractionType.Popup
            | InteractionType.Redirect
            | null;
        extraQueryParameters?: Record<string, string>;
        extraScopes?: string[];
    }>(),
    {
        label: 'Inloggen',
        icon: 'pi pi-sign-in',
        interactionType: null,
        scopes: null,
        extraQueryParameters: () => ({}),
        extraScopes: () => [],
    }
);

// EN: Login
// NL: Inloggen
// FR: Seconnecter

const {
    login,
    loading: loginLoading,
    disabled: loginDisabled,
} = useLogin({
    interactionType: () => props.interactionType,
    extraQueryParameters: () => props.extraQueryParameters,
    extraScopes: () => props.extraScopes,
});
</script>

<template>
    <Button
        :label="props.label ?? undefined"
        :icon="icon ?? undefined"
        :loading="loginLoading || props.loading"
        :disabled="loginDisabled || props.disabled"
        v-bind="$attrs"
        data-cy="login-btn"
        @click="login()"
    />
</template>
